"use client";
import { useState, useEffect } from "react";
import { useRouter } from "next/navigation";
import Image from "next/image";
import { loginCollegeAdmin } from "../services/api";

export default function LoginPage() {
  const router = useRouter();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [toast, setToast] = useState({ message: "", type: "" });

  const handleLogin = async (e) => {
    e.preventDefault();
    setToast({ message: "", type: "" });
    setLoading(true);

    try {
      const data = await loginCollegeAdmin(email, password);

      localStorage.setItem("collegeAdminToken", data.collegeAdminToken);

      if (data.refreshToken) {
        localStorage.setItem("collegeAdminRefreshToken", data.refreshToken);
      }

      if (data.admin) {
        localStorage.setItem("collegeAdmin", JSON.stringify(data.admin));
      }

      setToast({ message: "Login successful!", type: "success" });

      setTimeout(() => {
        router.push("/dashboard");
      }, 1500);
    } catch (err) {
      console.error("Login error:", err);
      setToast({
        message:
          err.response?.data?.detail ||
          "Login failed. Please check your credentials.",
        type: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (toast.message) {
      const timer = setTimeout(() => setToast({ message: "", type: "" }), 3000);
      return () => clearTimeout(timer);
    }
  }, [toast]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-50 to-blue-100 px-4 relative">
      {toast.message && (
        <div
          className="fixed top-5 right-5 px-5 py-3 rounded-lg shadow-lg z-50 animate-slideIn"
          style={{
            backgroundColor: toast.type === "success" ? "#22c55e" : "#ef4444",
            color: "white",
          }}
        >
          {toast.message}
        </div>
      )}

      <div className="max-w-md w-full bg-white rounded-2xl shadow-2xl p-8">
        <div className="flex flex-col items-center mb-8">
          <Image
            src="/logos/apexBeatLogo.svg"
            alt="ApexBeat.ai Logo"
            width={60}
            height={45}
            className="object-contain"
          />
          <Image
            src="/logos/apexBeat.ai.svg"
            alt="ApexBeat.ai Text"
            width={90}
            height={22}
            className="object-contain mt-2"
          />
          <h2 className="text-xl font-semibold text-gray-700 mt-4">
            College Admin Login
          </h2>
        </div>

        <form onSubmit={handleLogin} className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Email Address
            </label>
            <input
              type="email"
              placeholder="admin@college.edu"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Password
            </label>
            <input
              type="password"
              placeholder="••••••••"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            />
          </div>

          <button
            type="submit"
            disabled={loading}
            className="w-full bg-blue-600 hover:bg-blue-700 text-white font-semibold py-3 rounded-lg transition-colors disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2"
          >
            {loading ? (
              <>
                <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-white"></div>
                Logging in...
              </>
            ) : (
              "Login"
            )}
          </button>
        </form>
      </div>
    </div>
  );
}
